import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import MainLayout from '@/layouts/MainLayout.vue'
import Dashboard from '@/views/dashboard/index.vue'
import BookingList from '@/views/booking/list.vue'
import BookingAdd from '@/views/booking/add.vue'
import BookingDetail from '@/views/booking/detail.vue'
import BookingConfirm from '@/views/booking/confirm.vue'
import VipList from '@/views/vip/list.vue'
import VipAdd from '@/views/vip/add.vue'
import VipEdit from '@/views/vip/edit.vue'
import VipPackageTypes from '@/views/vip/package-types.vue'
import VipIncomeStatistics from '@/views/vip/income-statistics.vue'
import VipAdminPurchase from '@/views/vip/admin-purchase.vue'
import VipAuditLogs from '@/views/vip/audit-logs.vue'
import ScheduleList from '@/views/schedule/list.vue'
import ScheduleUnavailable from '@/views/schedule/unavailable.vue'
import ScheduleWeekly from '@/views/weekly-calendar/index.vue'
import CustomerList from '@/views/customer/list.vue'
import CustomerAdd from '@/views/customer/add.vue'
import CustomerDetail from '@/views/customer/detail.vue'
import CustomerEdit from '@/views/customer/edit.vue'
import CustomerVipDetail from '@/views/customer/vip-detail.vue'
import TeacherList from '@/views/teacher/list.vue'
import TeacherAdd from '@/views/teacher/add.vue'
import TeacherDetail from '@/views/teacher/detail.vue'
import TeacherEdit from '@/views/teacher/edit.vue'
import HorseList from '@/views/horse/list.vue'
import HorseAdd from '@/views/horse/add.vue'
import HorseDetail from '@/views/horse/detail.vue'
import HorseEdit from '@/views/horse/edit.vue'
import Profile from '@/views/profile/index.vue'
import Settings from '@/views/settings/index.vue'
import Posters from '@/views/posters/index.vue'
import SwiperImageManagement from '@/views/image-management/SwiperImageManagement.vue'
import HorseImageManagement from '@/views/image-management/HorseImageManagement.vue'
import CoachImageManagement from '@/views/image-management/CoachImageManagement.vue'
import ChangePassword from '@/views/profile/change-password.vue'
import NotFound from '@/views/error/404.vue'
import Login from '@/views/login/index.vue'
import Locked from '@/views/locked/index.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/locked',
    name: 'Locked',
    component: Locked,
    meta: { public: true }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: 'Dashboard', icon: 'HomeFilled' }
      },
      {
        path: 'booking',
        name: 'Booking',
        component: BookingList,
        meta: { title: 'Booking Management', icon: 'Calendar' }
      },
      {
        path: 'booking/add',
        name: 'AddBooking',
        component: BookingAdd,
        meta: { title: 'Add Booking', hidden: true }
      },
      {
        path: 'booking/detail/:id',
        name: 'BookingDetail',
        component: BookingDetail,
        meta: { title: 'Booking Detail', hidden: true }
      },
      {
        path: 'booking/confirm',
        name: 'ConfirmBooking',
        component: BookingConfirm,
        meta: { title: 'Confirm Booking', hidden: true }
      },
      {
        path: 'vip',
        name: 'Vip',
        component: VipList,
        meta: { title: 'VIP Management', icon: 'Money' }
      },
      {
        path: 'vip/package-types',
        name: 'VipPackageTypes',
        component: VipPackageTypes,
        meta: { title: 'VIP Package Types', icon: 'Collection' }
      },
      {
        path: 'vip/add',
        name: 'AddVip',
        component: VipAdd,
        meta: { title: 'Add VIP Package', hidden: true }
      },
      {
        path: 'vip/edit/:id',
        name: 'EditVip',
        component: VipEdit,
        meta: { title: 'Edit VIP Package', hidden: true }
      },
      {
        path: 'vip/statistics',
        name: 'VipIncomeStatistics',
        component: VipIncomeStatistics,
        meta: { title: 'VIP Income Statistics', icon: 'TrendCharts' }
      },
      {
        path: 'vip/admin-purchase',
        name: 'VipAdminPurchase',
        component: VipAdminPurchase,
        meta: { title: 'Admin Purchase for Customer', icon: 'ShoppingCart' }
      },
      {
        path: 'vip/audit-logs',
        name: 'VipAuditLogs',
        component: VipAuditLogs,
        meta: { title: 'VIP Audit Logs', icon: 'Document' }
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: ScheduleList,
        meta: { title: 'Schedule', icon: 'Clock' }
      },
      {
        path: 'schedule/unavailable',
        name: 'SetUnavailable',
        component: ScheduleUnavailable,
        meta: { title: 'Set Unavailable Time', icon: 'Clock' }
      },
      {
        path: 'schedule/weekly',
        name: 'WeeklyCalendar',
        component: ScheduleWeekly,
        meta: { title: 'Weekly Calendar', icon: 'Clock' }
      },
      {
        path: 'customer',
        name: 'Customer',
        component: CustomerList,
        meta: { title: 'Customers', icon: 'UserFilled' }
      },
      {
        path: 'customer/add',
        name: 'AddCustomer',
        component: CustomerAdd,
        meta: { title: 'Add Customer', hidden: true }
      },
      {
        path: 'customer/detail/:id',
        name: 'CustomerDetail',
        component: CustomerDetail,
        meta: { title: 'Customer Detail', hidden: true }
      },
      {
        path: 'customer/edit/:id',
        name: 'EditCustomer',
        component: CustomerEdit,
        meta: { title: 'Edit Customer', hidden: true }
      },
      {
        path: 'customer/vip/:id',
        name: 'CustomerVipDetail',
        component: CustomerVipDetail,
        meta: { title: 'VIP Details', hidden: true }
      },
      {
        path: 'teacher',
        name: 'Teacher',
        component: TeacherList,
        meta: { title: 'Teachers', icon: 'User' }
      },
      {
        path: 'teacher/add',
        name: 'TeacherAdd',
        component: TeacherAdd,
        meta: { title: 'Add Teacher', hidden: true }
      },
      {
        path: 'teacher/detail/:id',
        name: 'TeacherDetail',
        component: TeacherDetail,
        meta: { title: 'Teacher Detail', hidden: true }
      },
      {
        path: 'teacher/edit/:id',
        name: 'EditTeacher',
        component: TeacherEdit,
        meta: { title: 'Edit Teacher', hidden: true }
      },
      {
        path: 'horse',
        name: 'Horse',
        component: HorseList,
        meta: { title: 'Horses', icon: 'Collection' }
      },
      {
        path: 'horse/add',
        name: 'AddHorse',
        component: HorseAdd,
        meta: { title: 'Add Horse', hidden: true }
      },
      {
        path: 'horse/detail/:id',
        name: 'HorseDetail',
        component: HorseDetail,
        meta: { title: 'Horse Detail', hidden: true }
      },
      {
        path: 'horse/edit/:id',
        name: 'EditHorse',
        component: HorseEdit,
        meta: { title: 'Edit Horse', hidden: true }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: { title: 'Personal Settings', icon: 'Setting' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: { title: 'System Settings', icon: 'Tools' }
      },
      {
        path: 'posters',
        name: 'Posters',
        component: Posters,
        meta: { title: 'Posters', icon: 'Picture' }
      },
      {
        path: 'swiper-images',
        name: 'SwiperImages',
        component: SwiperImageManagement,
        meta: { title: 'Swiper Images', icon: 'Picture' }
      },
      {
        path: 'horse-images',
        name: 'HorseImages',
        component: HorseImageManagement,
        meta: { title: 'Horse Images', icon: 'Picture' }
      },
      {
        path: 'coach-images',
        name: 'CoachImages',
        component: CoachImageManagement,
        meta: { title: 'Coach Images', icon: 'Picture' }
      },
      {
        path: 'profile/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: { title: 'Change Password', hidden: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Critical: prevents browser from re-enabling bars
    if (savedPosition) return savedPosition;
    return { top: 0 };
  }
})

// Navigation guard - optimized for performance
router.beforeEach((to, from, next) => {
  const startTime = performance.now()
  const userStore = useUserStore()
  
  console.log(`[Router Guard] ${new Date().toLocaleTimeString()} - to: ${to.path}, isLoggedIn: ${userStore.isLoggedIn}`)
  
  // BLOCK EXTERNAL NAVIGATION THAT BREAKS FULLSCREEN
  if (to.fullPath.startsWith('http')) {
    window.open(to.fullPath, '_self');
    return;
  }
  
  // Session already loaded in main.js, just check login state
  if (!to.meta.public && !userStore.isLoggedIn) {
    console.log(`[Router Guard] Redirecting to /login (not logged in)`)
    next('/login')
  } else if (to.path === '/login' && userStore.isLoggedIn) {
    console.log(`[Router Guard] Redirecting to /dashboard (already logged in)`)
    next('/dashboard')
  } else if (to.meta.public) {
    // Check if software is still locked when accessing /locked
    if (to.path === '/locked') {
      const isLocked = localStorage.getItem('software-locked') === 'true'
      if (!isLocked && userStore.isLoggedIn) {
        console.log(`[Router Guard] Software unlocked, redirecting to /dashboard`)
        next('/dashboard')
      } else {
        next()
      }
    } else {
      // Allow other public routes (login, etc.)
      next()
    }
  } else {
    // Check if software is locked
    const isLocked = localStorage.getItem('software-locked') === 'true'
    if (isLocked && to.path !== '/locked') {
      console.log(`[Router Guard] Software is locked, redirecting to /locked`)
      next('/locked')
    } else {
      console.log(`[Router Guard] Calling next() for ${to.path}`)
      next()
    }
  }
})

router.afterEach((to) => {
  console.log(`[Router After] ${new Date().toLocaleTimeString()} - Navigation to ${to.path} completed`)
})

// Global error handler for routing errors - prevents one failed route from breaking everything
router.onError((error) => {
  console.error('[Router Error]', error)
  
  // Don't block navigation on component loading errors
  if (error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Cannot read properties') ||
      error.message.includes('is not iterable')) {
    console.warn('[Router Error] Non-critical error, continuing navigation')
    return
  }
  
  // For critical errors, redirect to dashboard as fallback
  const currentPath = window.location.pathname
  if (currentPath !== '/dashboard' && currentPath !== '/login') {
    console.warn('[Router Error] Redirecting to dashboard due to critical error')
    router.push('/dashboard').catch(() => {
      // If dashboard also fails, try login
      router.push('/login').catch(() => {
        console.error('[Router Error] All fallback routes failed')
      })
    })
  }
})

// Store router instance globally for error handling
window.router = router

export default router